// Dev-only: webpack proxy + storefront Origin (see vue.config.js). Must stay false in production builds.
import { DEFAULT_CRM_BASE_URL } from '@/config/cdaOptIn'

const tsApiBase =
  process.env.VUE_APP_USE_TS_API_PROXY === 'true'
    ? '/dev-api-ts'
    : 'https://api.travelski.com'

const crmBase = (
  process.env.VUE_APP_CRM_BASE_URL || DEFAULT_CRM_BASE_URL
).replace(/\/$/, '')

const endpoints = {
  catalog: `${tsApiBase}/catalog-manager`,
  auth: `${tsApiBase}/account/BookingFunnelContact`,
  user: `${tsApiBase}/user`,
  bookingCustomer: `${tsApiBase}/booking-customer`,
  images: 'https://d1wek41qnoimq7.cloudfront.net/',
  docs: `${tsApiBase}/documents/v3`,
  env: '/account/config/env',
  pagemeta: 'https://api-migdal.travelfactory.fr/cms/pagemeta',
  menu: 'https://cms.travelfactory.fr/menu',
  login: 'https://cse.travelski.com/page/${company}/login.html',
  cseLogout: 'https://cse.travelski.com/page/${company}/${company}',
  companyData: 'https://api-migdal.travelfactory.fr/cms/company/single-company', // Added endpoint
  /** Public CRM (CDA opt-in /subscribe/v2 + /optin/status) — default in config/cdaOptIn */
  crm: crmBase,
}

export default endpoints
